const data = {
    data () {
        return {
            filterPopup: {
                id: false,
                top: 0,
                left: 0,
                width: 0
            },
            filterRenderKey: 0
        }
    },
    methods: {
        openFilter (e, col_id) {
            this.filterPopup.id = col_id
            let rect = e.path[1].getBoundingClientRect()
            this.filterPopup.top = rect.y;
            this.filterPopup.left = rect.x;
            this.filterPopup.width = rect.width;
            this.filterReRender()
        },
        filterReRender () {
            this.filterRenderKey += 1
        },
        closeFilter () {
            this.filterPopup = {
                id: false,
                top: 0,
                left: 0,
                width: 0
            }
        }
    }
}

export default data